import { GraphQLClient } from 'graphql-request';

const graphqlUrl = process.env.NEXT_PUBLIC_SANITY_GRAPHQL || '';

if(!graphqlUrl){
  throw new Error('No graphql Url provided. Make sure to add NEXT_PUBLIC_SANITY_GRAPHQL in env!');
}

export const graphqlClient = new GraphQLClient(graphqlUrl);
